import RoundedButton from "../RoundedButton/RoundedButton";

// components
import PropertyCardTest from "../PropertyCard/PropertyCardTest";

// hooks
import useMostPopularProperties from "../../hooks/useMostPopularProperties";
import useTrendingProperties from "../../hooks/useTrendingProperties";
import useRecommendedProperties from "../../hooks/useRecommendedProperties";

// media
import rightArrowWhiteImg from '../../media/right-arrow-white.svg';

// utils
import { Test } from "../../platformUtils";

function TopPropertiesCarousel() {
    const mostPopularProperties = useMostPopularProperties();
    const trendingProperties = useTrendingProperties();
    const recommendedProperties = useRecommendedProperties();

    let mostPopularPropertyCards = (mostPopularProperties.map((popularProperty: Test) => {
        return <PropertyCardTest key={`${popularProperty.address}_${popularProperty.tokenId}`} property={popularProperty} size='md'></PropertyCardTest>
    }));

    // TODO: add switcher tabs for trending and recommended properties - probably as a separate component - and then add functionality to change which cards are being shown
    
    return (
        <div>
            <div className="flex justify-between mb-10">
                <RoundedButton>Most Popular</RoundedButton>
                <RoundedButton icon={rightArrowWhiteImg}>Explore more</RoundedButton>
            </div>
            <div className="flex justify-between space-x-8">
                {mostPopularPropertyCards}
            </div>
        </div>
    );
}

export default TopPropertiesCarousel;